import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { verificated, setUsername } from '../../redux/slices/Auth/login'
import { show as showDrawerRight } from '../../redux/slices/Drawer/drawerRight'
import { show as showDrawerLeft } from '../../redux/slices/Drawer/drawerLeft'
import * as rdx from '../../redux/slices/Search/input'

import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material'
import { Logout } from '@mui/icons-material'
import { styled } from '@mui/material/styles'
import { getUserById } from '../../services'
import * as rt from '../../config/routeType'
import _ from 'lodash'

const TextLabel = styled('div')(() => ({
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '0.875em',
  lineHeight: '1.5em',
  paddingLeft: '2em',
  color: 'rgba(0, 0, 0, 0.87)',
}))

const styleAvatar = {
  width: 26,
  height: 26,
  background: '#BBDEFB',
  color: '#2196F3',
}

const AccountMenu = ({ user, windowWidth }) => {
  const dispatch = useDispatch()
  let navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null)
  const username = useSelector(state => state.login.username)

  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    window.localStorage.removeItem('arbolQR_Token')
    window.localStorage.removeItem('arbolQR_Map_Zoom')
    window.localStorage.removeItem('arbolQR_Map_lng')
    window.localStorage.removeItem('arbolQR_Map_lat')
    dispatch(rdx.basicListInitial())
    dispatch(rdx.filterListInitial())
    dispatch(rdx.setEnabledFilter(false))
    dispatch(verificated(null))
    dispatch(setUsername(null))
    dispatch(showDrawerLeft(false))
    dispatch(showDrawerRight(false))
    navigate('/', { replace: true })
  }

  const handleProfile = () => {
    dispatch(showDrawerRight(false))
    dispatch(showDrawerLeft(false))
    navigate(rt.PROFILE)
  }

  useEffect(() => {
    if (username) return
    const tokenLocal = window.localStorage.getItem('arbolQR_Token')
    getUserById(user.id, `Bearer ${tokenLocal}`)
      .then(res => {
        const user = res.user
        let username = `${user?.nombre} ${user?.apellido}`
        username =
          username.length > 18 ? `${user?.nombre[0]} ${user?.apellido}` : username
        dispatch(setUsername(username))
      })
      .catch(err => {
        console.log('Error: ', err)
        setUsername(_.capitalize(user?.rol?.[0]))
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'end' }}>
        {windowWidth >= 670 ? <TextLabel>{username}</TextLabel> : null}
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}>
            <Avatar sx={styleAvatar}>{username?.[0]}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <MenuItem onClick={handleProfile}>
          <Avatar sx={styleAvatar} /> Mi cuenta
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </>
  )
}

export default AccountMenu
